
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_1n6oz_141",
  "variant-secondary": "awsui_variant-secondary_4c84z_1n6oz_210",
  "variant-primary": "awsui_variant-primary_4c84z_1n6oz_245",
  "variant-info": "awsui_variant-info_4c84z_1n6oz_278",
  "variant-value-large": "awsui_variant-value-large_4c84z_1n6oz_313",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_1n6oz_345",
  "variant-recovery": "awsui_variant-recovery_4c84z_1n6oz_378",
  "button": "awsui_button_4c84z_1n6oz_411",
  "color-inverted": "awsui_color-inverted_4c84z_1n6oz_446",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_1n6oz_467",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_1n6oz_474",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_1n6oz_480",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_1n6oz_486",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_1n6oz_493",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_1n6oz_500",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_1n6oz_507",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_1n6oz_514",
  "font-size-inherit": "awsui_font-size-inherit_4c84z_1n6oz_521",
  "icon-wrapper": "awsui_icon-wrapper_4c84z_1n6oz_529",
  "icon": "awsui_icon_4c84z_1n6oz_529"
};
  